import AudioTagPlayer from './AudioTagPlayer';
export default class VoicePlayer implements IPlayer {
    play(audioSource: string): void {
        this.player.play(audioSource);
    }
    stop(): void {
        this.player.stop();
    }
    pause(): void {
        this.player.pause();
    }
    private static instance: VoicePlayer;
    private static installed: boolean = false;
    private player: IPlayer;
    private constructor() {
        this.player = AudioTagPlayer.getInstance();
    }

    private static getInstance() {
        if (!VoicePlayer.instance) {
            VoicePlayer.instance = new VoicePlayer();
        }
        return VoicePlayer.instance;
    }

    static install(Vue) {
        if (VoicePlayer.installed) return;
        Vue.prototype.$Player = VoicePlayer.getInstance();
        VoicePlayer.installed = true;
    }
}


// WEBPACK FOOTER //
// ./src/components/Player/player.ts